﻿import { RetrieveRequest, ServiceOptions, serviceRequest } from "@serenity-is/corelib";
import { RowInfo } from "./RowInfo";

export namespace RowInfoService {
    export const baseUrl = 'Data/RowInfo';

    export declare function GetInfo(request: RetrieveRequest, onSuccess?: (response: RowInfo) => void, opt?: ServiceOptions<any>): PromiseLike<RowInfo>;

    export const Methods = {
        GetInfo: "Data/RowInfo/GetInfo"
    } as const;

    [
        'GetInfo'
    ].forEach(x => {
        (<any>RowInfoService)[x] = function (r, s, o) {
            return serviceRequest(baseUrl + '/' + x, r, s, o);
        };
    });
}